const ko = {
    common: {
      loading: '로딩 중...',
      error: '문제가 발생했습니다',
      cancel: '취소',
      save: '저장',
      saving: '저장 중...',
      copy: '복사',
      copied: '복사됨!',
      goHome: '홈으로',
      back: '뒤로',
      playAudyn: 'Audyn 플레이',
      reload: '새로고침',
      or: '또는',
      you: '나',
      vs: 'VS',
      songs: '노래',
      tracks: '트랙',
      score: '점수',
      rank: '순위',
      correct: '정답',
      accuracy: '정확도',
      today: '오늘',
      daily: '데일리',
      streak: '연속',
      profile: '프로필',
      guest: '게스트',
    },
  
    nav: {
      dailyChallenge: '데일리 챌린지',
      leaderboard: '리더보드',
      profile: '프로필',
      logIn: '로그인',
    },
  
    home: {
      title: '노래를 맞춰봐',
      subtitle: 'Spotify 플레이리스트를 붙여넣고, 클립을 들으며, 곡을 맞춰보세요.',
      playersToday: '오늘 {count}명 플레이 중',
      playlistInput: 'https://open.spotify.com/playlist/...',
      loadPlaylist: '플레이리스트 불러오기',
      tryDemo: '데모 체험 — Today\'s Top Hits',
      recentlyPlayed: '최근 플레이',
      featuredPlaylists: '인기 플레이리스트',
      songs: '노래',
      difficulty: '난이도',
      gameMode: '게임 모드',
      guessMode: '정답 모드',
      clips: '클립',
      startGame: '게임 시작',
      challengeFriend: '⚔️ 친구에게 도전',
      changePlaylist: '플레이리스트 변경',
      playableTracks: '재생 가능 트랙 {count}개',
      playableOfTotal: '{total}개 중 {playable}개 재생 가능',
      allGuessable: '{total}개 모두 정답 목록에 있습니다',
      beatScore: '⚔️ {username}의 점수 {score}를 이겨보세요!',

      announcement: {
        title: '🎉 이제 대용량 플레이리스트를 지원합니다!',
        message: '100곡 이상의 플레이리스트를 이제 지원합니다. 로드하는 데 잠시 시간이 걸릴 수 있습니다.',
      },

      loadingPreviews: '미리듣기 로딩 중…',
      back: '뒤로',
      backToPlaylist: '플레이리스트 선택으로 돌아가기',
      easy: '쉬움',
    },
  
game: {
      tapToBegin: '탭하여 시작',
      tapToUnlock: '화면을 탭하여 오디오를 활성화하세요',
      listening: '듣는 중...',
      ready: '준비 완료',
      tapReplay: '다시 재생',
      loadingAudio: '로딩 중...',
      skipped: '건너뜀',
      audioError: '오디오 오류',
      typeGuess: '정답을 입력하세요...',
      typeArtist: '아티스트 이름을 입력하세요...',
      checking: '확인 중...',
      skip: '건너뛰기',
      timePressure: '시간 압박',
      nextSong: '다음 노래',
      seeResults: '결과 보기',
      betterLuck: '다음엔 더 잘할 수 있어요',
      correctArtist: '아티스트 정답!',
      theArtistWas: '아티스트: {artist}',
      openInSpotify: 'Spotify에서 열기',
      base: '기본',
      timePenalty: '시간 페널티',
      streakMultiplier: '× {mult} 연속 보너스',
      kbPlay: '[Space] 재생',
      kbGuess: '[Enter] 정답 입력',
      kbClear: '[Esc] 지우기',
    },
  
    end: {
      newPersonalBest: '🏆 새로운 개인 최고 기록!',
      copyLink: '링크 복사',
      copyShareText: '공유 텍스트 복사',
      challengeFriend: '친구에게 도전',
      copyManually: '직접 복사:',
      playAgain: '다시 플레이',
      newPlaylist: '새 플레이리스트',
      viewLeaderboard: '리더보드 보기',
      createAccount: '계정을 만들어 점수를 저장하고 배지를 획득하세요',
      signUp: '회원가입',
      outOf: '{max}점 중',
      missedTracks: '놓친 트랙',
      scoreCard: '점수 카드',
      shareText: '{playlist}에서 {score}/{max} 달성 🎵 ({difficulty} • {tracks}곡) — 이길 수 있나요? {link}',
    },
  
    daily: {
      title: '데일리 챌린지',
      todaysChallenge: '오늘의 챌린지',
      classicMode: '🎵 클래식 모드 • 시간 제한 없음',
      playToday: '오늘의 챌린지 플레이',
      alreadyPlayed: '✅ 오늘의 챌린지를 이미 완료했습니다',
      signInToSave: '데일리 연속 기록을 저장하려면 로그인하세요',
      firstDay: '첫 번째 날! 계속 도전하세요.',
      dayStreak: '{count}일 연속',
      couldNotLoad: '데일리 챌린지를 불러오지 못했습니다',
      needsCache: '데일리 플레이리스트는 캐시를 위해 한 번 재생해야 합니다.',
      alreadyPlayedToast: '오늘의 챌린지는 이미 플레이했습니다!',
    },
  
    leaderboard: {
      title: '리더보드',
      global: '🏆 글로벌',
      daily: '📅 데일리',
      allTime: '전체 기간',
      month: '이번 달',
      week: '이번 주',
      noEntries: '아직 기록이 없습니다',
      beFirst: '첫 번째 플레이어가 되어 순위를 차지하세요!',
      yourRank: '내 순위',
      rankedByTimePressure: '시간 압박 점수 기준 순위',
      classicMode: '🎵 클래식',
      tickingMode: '⏱️ 타임어택',
      songMode: '🎵 노래 제목',
      artistMode: '🎤 아티스트',
    },
  
    login: {
      title: '로그인',
      email: '이메일',
      emailPlaceholder: 'you@example.com',
      password: '비밀번호',
      passwordPlaceholder: '••••••••',
      logInBtn: '로그인',
      signingIn: '로그인 중...',
      noAccount: '계정이 없으신가요?',
      signUpLink: '회원가입',
      welcomeBack: '돌아오신 것을 환영합니다!',
      fillFields: '모든 필드를 입력해 주세요',
      loginFailed: '로그인 실패',
    },
  
    register: {
      title: '회원가입',
      saveProgress: '진행 상황 저장',
      saveProgressDesc: '리더보드에 점수를 남기려면 계정을 만드세요.',
      username: '사용자 이름',
      usernamePlaceholder: 'your_username',
      email: '이메일',
      emailPlaceholder: 'you@example.com',
      password: '비밀번호',
      passwordPlaceholder: '최소 8자 이상',
      bio: '자기소개',
      bioPlaceholder: '나에 대해 조금...',
      optional: '선택 사항',
      createAccount: '계정 만들기',
      saveAccount: '계정 저장',
      creating: '만드는 중...',
      haveAccount: '이미 계정이 있으신가요?',
      logInLink: '로그인',
      welcomeToAudyn: 'Audyn에 오신 것을 환영합니다!',
      accountCreated: '계정이 생성되었습니다! 점수가 보존되었습니다.',
      fillRequired: '필수 항목을 모두 입력해 주세요',
      passwordMin: '비밀번호는 최소 8자 이상이어야 합니다',
      registrationFailed: '회원가입 실패',
    },
  
    profile: {
      title: '프로필',
      editProfile: '프로필 편집',
      displayName: '표시 이름',
      displayNamePlaceholder: '표시 이름 (선택 사항)',
      displayNameHint: '{count}/50 — 비워두면 사용자 이름이 표시됩니다',
      bioPlaceholder: '짧은 자기소개를 작성하세요...',
      spotify: 'Spotify',
      spotifyPlaceholder: 'https://open.spotify.com/user/your_id',
      spotifyError: 'https://open.spotify.com/user/ 로 시작해야 합니다',
      instagram: 'Instagram',
      instagramError: '영문자, 숫자, 밑줄, 점만 사용 가능 (1–30자)',
      pinterest: 'Pinterest',
      pinterestError: '영문자, 숫자, 밑줄, 점만 사용 가능 (3–30자)',
      achievements: '업적',
      playToEarn: '게임을 플레이하여 업적을 획득하세요!',
      recentScores: '최근 점수',
      profileUpdated: '프로필이 업데이트되었습니다',
      avatarUpdated: '아바타가 업데이트되었습니다',
      profileLinkCopied: '프로필 링크가 복사되었습니다!',
      signInToView: '프로필을 보려면 로그인하세요',
      onlyJpgPngWebp: 'JPEG, PNG, WebP만 가능',
    },
  
    publicProfile: {
      userNotFound: '사용자를 찾을 수 없습니다',
      userNotExist: '이 사용자는 존재하지 않습니다.',
    },
  
    share: {
      shareNotFound: '공유를 찾을 수 없습니다',
      shareExpired: '이 공유 링크는 만료되었거나 존재하지 않습니다.',
      playThisPlaylist: '이 플레이리스트 플레이',
      goToAudyn: 'Audyn으로 이동',
    },
  
    room: {
      roomCode: '방 코드',
      waitingForOpponent: '상대방을 기다리는 중...',
      shareCodeHint: '코드나 링크를 공유하세요. 방은 30분 후 만료됩니다.',
      cancelRoom: '취소',
      opponent: '상대방',
      playAgain: '다시 플레이',
      wonBy: '{diff}점 차이로 승리했습니다! 🏆',
      tie: '무승부!',
      lostBy: '{diff}점 차이로 패배했습니다',
      h2hChallenge: '1대1 챌린지',
      roomLinkCopied: '방 링크가 복사되었습니다!',
      challengeLinkCopied: '챌린지 링크가 복사되었습니다! 친구에게 보내세요.',
      noPlaylist: '플레이리스트가 선택되지 않았습니다 — 먼저 플레이리스트를 불러오세요.',
    },
  
    errorBoundary: {
      title: '문제가 발생했습니다.',
      message: '다시 시도하려면 페이지를 새로고침하세요.',
      reload: '새로고침',
    },
  
    languages: {
      en: 'English',
      hi: 'हिन्दी',
      es: 'Español',
      ja: '日本語',
      ko: '한국어',
    },
  };
  
  export default ko;
